<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import FallbackAvatar from '@/components/ui/FallbackAvatar'
import api from '@/api'

export default {
  name: 'AppSettingsNavigation',
  components: {
    FallbackAvatar,
  },
  props: {
    activityBgColor: {
      type: String,
      default: 'accent',
    },
    navigationBgColor: {
      default: 'main-lighten-5',
      type: String,
    },
    routes: Array,
    settingsRoutes: Array,
    user: Object,
    value: Boolean,
    right: {
      type: Boolean,
      default: false,
    },
    advancedSearchType: String,
  },
  data() {
    return {
      open: false,
      search: null,
      isSettingsMenu: false,
    }
  },
  computed: {
    ...mapState('activities', [ 'unread_activities' ]),
  },
  watch: {
    value() {
      this.open = this.value
    },
    open() {
      this.$emit('input', this.open)
    },
    user(oldval, newval) {
      if (oldval !== newval && this.user) {
        this.getCountUnreadActivities()
        this.getSettingsMenu()
      }
    },
  },
  created() {
    if (this.user) {
      this.getCountUnreadActivities()
      this.getSettingsMenu()
    }
  },
  methods: {
    ...mapActions('activities', [ 'getCountUnreadActivities' ]),
    ...mapActions('auth', ['getSettingsMenu']),
    onSearch() {
      if (!this.search) return false

      if (this.$route.name === 'search-results' && this.$route.query.q !== this.search) {
        this.$router.push({ query: { q: this.search } })
      } else if (this.$route.query.q !== this.search) {
        this.$router.push({ name: 'search-results', query: { q: this.search } })
      }

      this.search = null
    },
    clearSearch() {
      this.search = ''
    },
    toggleAction(url) {
      api.items.editItem(url).then(_ => {
        this.getSettingsMenu()
      })
    },
  },
}
</script>
